import { render, staticRenderFns } from "./VBirthdayPicker.vue?vue&type=template&id=862404ea"
import script from "./VBirthdayPicker.vue?vue&type=script&lang=js"
export * from "./VBirthdayPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports